import * as React from 'react';
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { motion, AnimatePresence } from "motion/react";

interface TooltipProps {
  children: React.ReactNode;
  content: React.ReactNode;
  side?: "top" | "right" | "bottom" | "left";
}

export function Tooltip({ children, content, side = "top" }: TooltipProps) {
  return (
    <TooltipPrimitive.Root>
      <TooltipPrimitive.Trigger asChild>
        {children}
      </TooltipPrimitive.Trigger>
      <AnimatePresence>
        <TooltipPrimitive.Portal>
          <TooltipPrimitive.Content
            side={side}
            sideOffset={5}
            asChild
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.95, y: side === "top" ? 5 : -5 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.95, y: side === "top" ? 5 : -5 }}
              className="z-[100] max-w-xs px-4 py-3 text-[11px] leading-relaxed font-medium bg-ink text-paper rounded-md shadow-overlay border border-paper/10"
            >
              {content}
              <TooltipPrimitive.Arrow className="fill-ink" />
            </motion.div>
          </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
      </AnimatePresence>
    </TooltipPrimitive.Root>
  );
}
